import Stack from '@mui/material/Stack'
import { Pie } from '@nivo/pie'
import AutoSizer from 'react-virtualized-auto-sizer'

interface Props {
  data: any[]
  title?: string
  colors?: any
}
interface Size {
  height: number
  width: number
}

const PieChart = ({ data, title, colors }: Props) => {
  return (
    <Stack alignItems={'center'}>
      {title || data[0].title}
      <AutoSizer style={{ width: '100%', height: 300 }}>
        {({ height, width }: Size) => {
          return (
            <Pie
              height={300}
              width={width}
              data={data}
              margin={{ left: 80, bottom: 40, right: 80, top: 40 }}
              colors={colors || data.map((line: any) => line.color)}
              isInteractive={true}
              animate={true}
              innerRadius={0.55}
              padAngle={3}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              borderWidth={1}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor='#333333'
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={{ from: 'color' }}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor={{
                from: 'color',
                modifiers: [['darker', 2]],
              }}
              borderColor={{
                from: 'color',
                modifiers: [['darker', 0.2]],
              }}
              valueFormat={(value) =>
                `${Number(value).toLocaleString('nl-NL', {
                  minimumFractionDigits: 2,
                })}%`
              }
              legends={
                width > 420
                  ? [
                      {
                        anchor: 'center',
                        direction: 'column',
                        justify: false,
                        translateX: -150,
                        translateY: 0,
                        itemsSpacing: 0,
                        itemDirection: 'left-to-right',
                        itemWidth: 80,
                        itemHeight: 20,
                        itemOpacity: 0.75,
                        symbolSize: 12,
                        symbolShape: 'circle',
                        symbolBorderColor: 'rgba(0, 0, 0, .5)',
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemBackground: 'rgba(0, 0, 0, .03)',
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]
                  : undefined
              }
            />
          )
        }}
      </AutoSizer>
    </Stack>
  )
}

export default PieChart
